const ACTION_WORD = { 'clock-in': 'in', 'clock-out': 'out' };

/**
 * Splits gate copy into renderable segments: resolves the `{{in|out}}` action
 * placeholder and marks the `**bold**` parts.
 */
export const getCopySegments = (text, action) =>
  text
    // An unknown action degrades to "in or out" instead of silently picking one.
    .replace(/\{\{(.+?)\}\}/g, (_, options) => ACTION_WORD[action] || options.split('|').join(' or '))
    .split('**')
    .map((value, i) => ({ value, bold: i % 2 === 1 }));
